import {
  EXECUTE_REPORT,
  EXECUTE_REPORT_CLEAR_DATA,
  EXECUTE_REPORT_ERROR,
  EXECUTE_REPORT_SUCCESS,
  POST_REPORTS,
  POST_REPORTS_CLEAR_DATA,
  POST_REPORTS_ERROR,
  POST_REPORTS_SUCCESS,
  REPORT_EXPORT_EXCEL,
  REPORT_EXPORT_EXCEL_CLEAR_DATA,
  REPORT_EXPORT_EXCEL_ERROR,
  REPORT_EXPORT_EXCEL_SUCCESS,
} from "./actionTypes";

export const reportsPost = (reportsBody) => {
  return {
    type: POST_REPORTS,
    payload: { reportsBody },
  };
};

export const reportsSuccess = (success) => {
  return {
    type: POST_REPORTS_SUCCESS,
    payload: success,
  };
};

export const reportsError = (error) => {
  return {
    type: POST_REPORTS_ERROR,
    payload: error,
  };
};

export const reportsClearData = () => {
  return {
    type: POST_REPORTS_CLEAR_DATA,
    payload: {},
  };
};

export const executeReports = (executeReportsBody) => {
  return {
    type: EXECUTE_REPORT,
    payload: { executeReportsBody },
  };
};

export const executeReportsSuccess = (success) => {
  return {
    type: EXECUTE_REPORT_SUCCESS,
    payload: success,
  };
};

export const executeReportsError = (error) => {
  return {
    type: EXECUTE_REPORT_ERROR,
    payload: error,
  };
};

export const executeReportsClearData = () => {
  return {
    type: EXECUTE_REPORT_CLEAR_DATA,
    payload: {},
  };
};

export const reportExportExcel = (reportsBody) => {
  return {
    type: REPORT_EXPORT_EXCEL,
    payload: { reportsBody },
  };
};

export const reportExportExcelSuccess = (success) => {
  return {
    type: REPORT_EXPORT_EXCEL_SUCCESS,
    payload: success,
  };
};

export const reportExportExcelError = (error) => {
  return {
    type: REPORT_EXPORT_EXCEL_ERROR,
    payload: error,
  };
};

export const reportExportExcelClearData = () => {
  return {
    type: REPORT_EXPORT_EXCEL_CLEAR_DATA,
    payload: {},
  };
};
